export const enum EChessMessage {
  HostCommand = 1,
  ClientRequest = 2,
  ClientRequestResponse = 3,
  Cursor = 10,
  CursorPick = 11,
  PieceCreate = 101,
  PieceKill = 102,
  PieceMove = 103,
  PieceMoveRequest = 104,
}
